import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

export const FileNotFound404 = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen p-6">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-3xl font-bold text-gray-800">
            Welcome to the Diversion Database
          </CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col items-center space-y-4">
          <img
            src={`${process.env.PUBLIC_URL}/logoODR.png`}
            alt="logo"
            className="h-20 w-auto"
          />
          <Alert variant="destructive" className="w-full">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>Page Not Found</AlertTitle>
            <AlertDescription>
              The page you are looking for does not exist.
            </AlertDescription>
          </Alert>
        </CardContent>
      </Card>
    </div>
  );
};